import React, { useCallback } from 'react'
import { Col, Form, Row } from 'react-bootstrap'

const ViewPlacementDataSelection = ({ formData, setFormData }) => {
    const handleInputChange = useCallback((e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value === "true" }));
    }, [setFormData]);

    return (
        <Row className="mt-3 gy-2">
            <Col xs={12} lg={6}>
                <Form.Group controlId="formViewPlacementData">
                    <Form.Label className="text-secondary">Show Placement Data</Form.Label>
                    <Form.Select
                        as="select"
                        name="viewPlacementData"
                        value={formData?.viewPlacementData}
                        onChange={handleInputChange}
                    >
                        <option value={true}>True</option>
                        <option value={false}>False</option>
                    </Form.Select>
                </Form.Group>
            </Col>
            <Col xs={12} lg={6}>
                <Form.Group controlId="formcreativeFtd">
                    <Form.Label className="text-secondary">Use Main Event's(sum) in creative</Form.Label>
                    <Form.Select
                        as="select"
                        name="creativeFtd"
                        value={formData?.creativeFtd}
                        onChange={handleInputChange}
                    >
                        <option value={true}>True</option>
                        <option value={false}>False</option>
                    </Form.Select>
                </Form.Group>
            </Col>
        </Row>
    );
};

export default ViewPlacementDataSelection; 